export default __webpack_public_path__ + "static/media/animated-support.64481042.png";